import { Result, Button, Image } from 'antd';
import { Fragment } from 'react';

import restriction_icon from 'assets/img/icons/svg/restriction.svg';

const NoAccessMessageResultNotAuthorized = ({ onUpgrade }) => {
  return (
    <Fragment>
      <Result
        icon={<Image src={restriction_icon} alt="restriction" />}

        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        // extra={<Button type="primary">Back Home</Button>}
      />
    </Fragment>
  );
};

export default NoAccessMessageResultNotAuthorized;
